var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"text-grey-darker text-2xl"},[_vm._v("\n          "+_vm._s(this.title)+"    \n    \t")]),_vm._v(" "),_c('div',{staticClass:"my-2 text-grey text-bold text-md"},[_vm._v("\n        "+_vm._s(this.subtitle)+"\n    \t")]),_vm._v(" "),_c('albums',{staticClass:"mt-4"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700326c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = null
// module chunks = 